var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99373 1.14526C9.61689 4.21052 11.6211 6.58526 13.9453 7.41052C11.6211 8.21894 9.61689 10.6105 8.99373 13.6758C8.37058 10.6105 6.36636 8.21894 4.04215 7.41052C6.38321 6.58526 8.38742 4.21052 8.99373 1.14526Z",
    fill: "#F4C110"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98135 8.43789C3.35188 10.2905 4.56451 11.7221 5.9624 12.2105C4.56451 12.7158 3.35188 14.1474 2.98135 16C2.61082 14.1474 1.39819 12.7158 0.000296568 12.2274C1.39819 11.7221 2.61082 10.2905 2.98135 8.43789Z",
    fill: "#F4C110"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45265 -0.000183474C3.75581 1.46508 4.69897 2.61034 5.81055 2.99771C4.69897 3.38508 3.73897 4.53034 3.45265 5.99561C3.14949 4.53034 2.20634 3.38508 1.09476 2.99771C2.20634 2.61034 3.16634 1.46508 3.45265 -0.000183474Z",
    fill: "#F4C110"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/Sparkle.11c0723c4e3bd43ad181f220e33c8783.svg";
export { ForwardRef as ReactComponent };